module.exports = __webpack_public_path__ + "assets/img/noorder.ae81fe1d.png";